var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasBadge)?_c('span',{staticClass:"organization-profile-status-badge",class:_vm.badgeClass},[_vm._v(" "+_vm._s(_vm.displayLabel)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }